module.exports = __webpack_public_path__ + "img/logo.028a696d.jpg";